/**
 * src/components/directory-page/DirectoryPage.js
 *
 * Página del directorio. Muestra FeaturedSection (Plan Oro).
 */

import { define, c } from '@components/Component.js'
import { h } from '@core/dom.js'

define('DirectoryPage', ({ params = {} } = {}) => {
    const initialCategory = params.categoria ?? ''

    return h('div', { className: 'page page--directory' },
        c('Header'),
        c('FeaturedSection', { initialCategory })
    )
})
